import React from 'react';
import { getdata, updatedata, sendwhatsappmessage} from "../../util/global";

const PrescriptionView = ({ mode, setmode, formdata }) => {
  if (mode !== "viewprescription") return null;

  const handleprint = () => {
    const content = document.getElementById('printarea').innerHTML;
    const frame = document.createElement('iframe');
    frame.style.display = 'none';
    document.body.appendChild(frame);
    const win = frame.contentWindow;
    win.document.write('<html><head><title>prescription</title>');
    // add minimal styles for the printed table
    win.document.write('<style>table { width: 100%; border-collapse: collapse; } th, td { border: 1px solid #ccc; padding: 10px; text-align: left; }</style>');
    win.document.write('</head><body>');
    win.document.write(content);
    win.document.write('</body></html>');
    win.document.close();
    win.print();
    document.body.removeChild(frame);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ width: '600px', position: 'relative' }}>
        
        <button 
          className="close-btn" 
          onClick={() => setmode("")} 
          style={{ position: 'absolute', top: '15px', right: '15px', fontSize: '24px' }}
        >
          &times;
        </button>

        <div id="printarea" style={{ padding: '20px' }}>
          <div style={{ textAlign: 'left', marginBottom: '20px', borderBottom: '2px solid #000', paddingBottom: '10px' }}>
            <h2 style={{ margin: 0 }}>Dr. House</h2>
            <p style={{ margin: 0 }}>123 health clinic street, medical city</p>
            <p style={{ margin: 0 }}>phone: +91 9876543210</p>
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
            <div><strong>Patient:</strong> {formdata.name}</div>
            <div><strong>Date:</strong> {formdata.datetime}</div>
          </div>

          <table className="grid" style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'left', padding: '10px' }}>Medicine</th>
                <th style={{ textAlign: 'left', padding: '10px' }}>Dosage</th>
                <th style={{ textAlign: 'left', padding: '10px' }}>Instructions</th>
              </tr>
            </thead>
            <tbody>
              {formdata.medicinedata?.map((row, index) => (
                <tr key={index}>
                  <td style={{ padding: '10px' }}>{row.medicine}</td>
                  <td style={{ padding: '10px' }}>{row.dosage}</td>
                  <td style={{ padding: '10px' }}>{row.instructions}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {formdata.notes && (
            <div style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px solid #eee' }}>
              <strong>Notes</strong>
              <p style={{ margin: '8px 0 0', whiteSpace: 'pre-wrap', fontSize: '14px' }}>{formdata.notes}</p>
            </div>
          )}
        </div>

        <div style={{ display: 'flex', gap: '10px', marginTop: '20px', justifyContent: 'flex-end' }}>
          <button className="btn-blue" onClick={handleprint}>Print</button>
        </div>
      </div>
    </div>
  );
};

export default PrescriptionView;